import React from 'react';
import { MiniCta } from '../CtaBlock';
import { AUTHOR_IMAGE } from '../../data/content';
export function About() {
  return <section className="bg-ink-900 px-4 py-14 sm:px-6 sm:py-20" data-id="element-45" data-mp="oqcfq4a242cv">
      <div className="mx-auto max-w-5xl" data-id="element-46" data-mp="12rf44noixoqy">
        <p className="text-center font-display text-xs font-bold uppercase tracking-[0.22em] text-arc-light lg:text-left" data-id="element-47" data-mp="12qdhdly5bdte">
          ⚙️ Perché abbiamo creato il Sistema Maestro di Saldatura™
        </p>

        <div className="mt-6 grid gap-8 lg:grid-cols-[minmax(0,20rem)_1fr] lg:items-start lg:gap-10" data-id="element-48" data-mp="azz86312upo2">
          <figure className="mx-auto w-full max-w-xs lg:mx-0 lg:max-w-none" data-id="element-49" data-mp="62h7ezx7rgr5">
            <img src={AUTHOR_IMAGE} alt="Saldatore professionista nella sua officina" className="w-full rounded-2xl border border-ink-500 object-cover" width={864} height={1080} data-id="element-50" data-mp="jsuel02a6rff" />
            <figcaption className="mt-3 text-center text-[13px] font-semibold text-mute lg:text-left" data-id="element-51" data-mp="3jfsrepmsmf8t">
              Creato da saldatori professionisti con anni di officina alle spalle.
            </figcaption>
          </figure>

          <div className="space-y-4 text-[15px] leading-relaxed text-mute sm:text-lg" data-id="element-52" data-mp="3879zatkyy0eg">
            <p className="font-display text-xl font-bold uppercase leading-tight text-bone sm:text-2xl" data-id="element-53" data-mp="3cys11jutg50h">
              La maggior parte delle persone non ha difficoltà con la saldatura perché non è capace.
            </p>
            <p data-id="element-54" data-mp="2kbxg6lu373mh">
              Ha difficoltà perché nessuno gli ha mai mostrato cosa controllare prima di accendere la
              macchina.
            </p>
            <p data-id="element-55" data-mp="2u80sulmkekno">
              Imparano attraverso video sparsi. Un saldatore consiglia un’impostazione, un altro ne
              consiglia una completamente diversa.
            </p>
            <p data-id="element-56" data-mp="9ibdm7hy8wug">
              Sprecano materiale facendo prove e finiscono per pensare che saldare sia molto più
              difficile di quanto dovrebbe essere.
            </p>
            <p className="font-semibold text-arc-light" data-id="element-57" data-mp="ejile6k3dw14">
              Il Sistema Maestro di Saldatura™ è nato per cambiare questo.
            </p>
            <p data-id="element-58" data-mp="25m921we7uo9f">Non è un altro corso pieno di ore di teoria.</p>
            <p className="font-medium text-bone/90" data-id="element-59" data-mp="25nu1o0fe0xe5">
              È una guida pratica di riferimento progettata per aiutarti a sapere cosa controllare,
              cosa correggere e cosa fare ogni volta che saldi.
            </p>
          </div>
        </div>

        <MiniCta label="Voglio il sistema completo" data-id="element-60" data-mp="1ruks9zrfwbvm" />
      </div>
    </section>;
}